var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c(_vm.tag,_vm._b({tag:"component"},'component',_vm.$attrs,false),[_vm._t("default",null,{"disabled":_vm.isDisabled,"messages":_vm.messages})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }